import React from "react";

import NewSnapshot from "./newSnapshot";
import Snapshot from "./snapshot";
import {
  Report,
  ReportColumn,
  Snapshot as SnapshotType,
} from "/app/src/models";

/**
 * Renders the snapshots component.
 *
 * @param {Object} props - The props for the Snapshots component.
 * @param {Report} props.report - The report object containing data needed for the component.
 * @param {SnapshotType[]} props.snapshots - An array of snapshot objects to be displayed.
 * @param {ReportColumn[]} props.columns - An array of report columns for formatting the snapshots.
 * @returns {JSX.Element} The rendered snapshots component.
 */
export default function Snapshots({
  report,
  snapshots,
  columns,
}: {
  report: Report;
  snapshots: SnapshotType[];
  columns: ReportColumn[];
}) {
  return (
    <div className="snapshots">
      {snapshots.map((snapshot) => (
        <Snapshot
          snapshot={snapshot}
          key={snapshot.id}
          reportColumns={columns}
        />
      ))}
      <NewSnapshot report={report} reportColumns={columns} />
    </div>
  );
}
